import { getValidToken } from '../utils/tokenUtils';

export const fetchOrgDisplayNames = async () => {
  const token = await getValidToken();
  const res = await fetch('/api/organisations', {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!res.ok) {
    const text = await res.text().catch(() => null);
    const err = new Error(`Kunde inte hämta organisationsnamn (${res.status}).` + (text ? ` - ${text}` : ''));
    err.status = res.status;
    throw err;
  }

  const data = await res.json();
  return Array.isArray(data) ? data : [];
};

export const fetchOrganisations = async () => {
  const token = await getValidToken();
  const res = await fetch('/api/admin/organisations', {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!res.ok) {
    const text = await res.text().catch(() => null);
    const err = new Error(`Kunde inte hämta organisationer (${res.status}).` + (text ? ` - ${text}` : ''));
    err.status = res.status;
    throw err;
  }

  const data = await res.json();
  return Array.isArray(data) ? data : data.organisations || [];
};